import { render } from "./NewsSideBarSearch.vue?vue&type=template&id=58bdb97f"
import script from "./NewsSideBarSearch.vue?vue&type=script&lang=js"
export * from "./NewsSideBarSearch.vue?vue&type=script&lang=js"
script.render = render

export default script
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QInput,QIcon,QPopupProxy,QDate,QBtn,QSelect,QItem,QItemSection});qInstall(script, 'directives', {ClosePopup});
